import React from 'react';
import { Add as AddIcon, Save as SaveIcon } from '@mui/icons-material';
import { T, fontDisplay, fontBody } from './tokens';

export default function PageHeader({
  embedded,
  saving,
  isDirty,
  onSave,
  onCreate,
  showSave = false,
}) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 22, flexWrap: 'wrap', gap: 16 }}>
      <div>
        {!embedded && (
          <h1 style={{ fontFamily: fontDisplay, fontSize: 26, fontWeight: 700, color: T.ink, margin: 0 }}>
            Social Media Automation
          </h1>
        )}
        {embedded && (
          <div style={{ fontFamily: fontDisplay, fontSize: 18, fontWeight: 600, color: T.ink }}>Social Media Automation</div>
        )}
        <p style={{ fontFamily: fontBody, fontSize: 14, color: T.slate, margin: '6px 0 0' }}>
          Automatically reply to comments and messages from Facebook and Instagram.
        </p>
      </div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        {showSave && (
          <button
            type="button"
            onClick={onSave}
            disabled={saving || !isDirty}
            style={{
              display: 'flex', alignItems: 'center', gap: 8, fontFamily: fontBody, fontSize: 14, fontWeight: 600,
              color: T.ink, background: 'transparent', border: `1px solid ${T.line}`,
              padding: '10px 16px', borderRadius: 10, cursor: isDirty ? 'pointer' : 'not-allowed',
              opacity: isDirty ? 1 : 0.5,
            }}
          >
            <SaveIcon sx={{ fontSize: 16 }} /> {saving ? 'Saving…' : 'Save changes'}
          </button>
        )}
        {onCreate && (
          <button
            type="button"
            onClick={onCreate}
            style={{
              display: 'flex', alignItems: 'center', gap: 8, fontFamily: fontBody, fontSize: 14, fontWeight: 600,
              color: '#fff', background: T.blue, border: 'none',
              padding: '11px 18px', borderRadius: 10, cursor: 'pointer',
            }}
          >
            <AddIcon sx={{ fontSize: 18 }} /> Create automation
          </button>
        )}
      </div>
    </div>
  );
}
